<div class="cm-image-viewer">
    @if ($stage() !== "done") {
        <cm-loading-spinner class="cm-processing-overlay">
            <ng-container cm-text-bottom>
                @switch ($stage()) {
                    @case ("init") {
                        Loading...
                    }
                    @case ("waitingRenderOutput") {
                        @if ($renderJobData(); as renderJobData) {
                            @switch (renderJobData.state) {
                                @case (JobState.Cancelled) {
                                    <ng-container [ngTemplateOutlet]="renderJobLink" [ngTemplateOutletContext]="{jobId: renderJobData.id}"></ng-container> was
                                    cancelled...
                                }
                                @case (JobState.Running) {
                                    <ng-container [ngTemplateOutlet]="renderJobLink" [ngTemplateOutletContext]="{jobId: renderJobData.id}"></ng-container> in
                                    progress...

                                    <cm-button [disabled]="$cancellingRenderJob()" (click)="cancelRenderJob()" class="cm-cancel-button">
                                        <ng-container cm-left-icon>
                                            @if ($cancellingRenderJob()) {
                                                <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                                            } @else {
                                                <i class="fa-solid fa-stop"></i>
                                            }
                                        </ng-container>
                                        <ng-container cm-text>Cancel</ng-container>
                                    </cm-button>
                                }
                                @case (JobState.Runnable) {
                                    <ng-container [ngTemplateOutlet]="renderJobLink" [ngTemplateOutletContext]="{jobId: renderJobData.id}"></ng-container> has
                                    been queued...

                                    <cm-button [disabled]="$cancellingRenderJob()" (click)="cancelRenderJob()" class="cm-cancel-button">
                                        <ng-container cm-left-icon>
                                            @if ($cancellingRenderJob()) {
                                                <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                                            } @else {
                                                <i class="fa-solid fa-stop"></i>
                                            }
                                        </ng-container>
                                        <ng-container cm-text>Cancel</ng-container>
                                    </cm-button>
                                }
                                @default {
                                    Waiting for rendering output...
                                }
                            }
                        } @else {
                            Waiting for rendering output...
                        }
                    }
                    @case ("downloading") {
                        Downloading rendered image...
                    }
                    @case ("processing") {
                        Processing image...
                    }
                }
            </ng-container>
        </cm-loading-spinner>
    } @else {
        @if ($renderJobData(); as renderJobData) {
            @if ($isJobError()(renderJobData)) {
                <div class="cm-no-data">
                    <i class="cm-no-data-icon far fa-triangle-exclamation"></i>
                    <div class="cm-no-data-text">
                        <ng-container [ngTemplateOutlet]="renderJobLink" [ngTemplateOutletContext]="{jobId: renderJobData.id}"></ng-container
                        >{{ renderJobData.state === JobState.Cancelled ? " was cancelled" : " failed: " + renderJobData.message }}
                    </div>
                    <div class="cm-buttons-container">
                        <cm-button
                            [disabled]="$startingRenderJob() || $deletingRenderJob() || $overrideRenderJobData() !== undefined"
                            (click)="reRender()"
                            class="cm-render-button"
                        >
                            <ng-container cm-left-icon>
                                @if ($startingRenderJob()) {
                                    <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                                } @else {
                                    <i class="far fa-rotate-right"></i>
                                }
                            </ng-container>
                            <ng-container cm-text>Retry</ng-container>
                            <ng-container cm-left-icon></ng-container>
                        </cm-button>
                        <cm-button [disabled]="$startingRenderJob() || $deletingRenderJob()" (click)="discardRenderJob()" class="cm-delete-button">
                            <ng-container cm-left-icon>
                                @if ($deletingRenderJob()) {
                                    <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                                } @else {
                                    <i class="far fa-trash"></i>
                                }
                            </ng-container>
                            <ng-container cm-text>Remove</ng-container>
                            <ng-container cm-left-icon></ng-container>
                        </cm-button>
                    </div>
                </div>
            }
        } @else {
            <div class="cm-no-data">
                <i class="cm-no-data-icon far fa-image-slash"></i>
                <div [matTooltip]="$renderSettings() && $camera() ? '' : 'Add a render and camera node to generate an image'">
                    <cm-button [disabled]="!($renderSettings() && $camera()) || $startingRenderJob()" (click)="render()" class="cm-render-button">
                        <ng-container cm-left-icon>
                            @if ($startingRenderJob()) {
                                <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
                            } @else {
                                <i class="far fa-image"></i>
                            }
                        </ng-container>
                        <ng-container cm-text>Render this variation</ng-container>
                        <ng-container cm-left-icon></ng-container>
                    </cm-button>
                </div>
                @if (developmentMode && $renderQueueGroups().length) {
                    <mat-form-field matTooltip="Development only: render on a specific queue group instead of in the cloud" class="cm-render-queue-group">
                        <mat-label>Render queue group</mat-label>
                        <mat-select [value]="$renderQueueGroup()" (valueChange)="$renderQueueGroup.set($event)">
                            <mat-option value="">Cloud rendering</mat-option>
                            @for (queueGroup of $renderQueueGroups(); track queueGroup) {
                                <mat-option [value]="queueGroup">{{ queueGroup }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }
                @if ($viewType() === "tree") {
                    <div class="cm-no-data-text">
                        To render more variations change to
                        <span (click)="viewTypeChanged.emit('allVariations')" class="cm-change-mode">All variations.</span>
                    </div>
                }
            </div>
        }
    }

    @if ($result(); as result) {
        @if (!isError(result)) {
            @if ($renderJobData(); as renderJobData) {
                @if ($isJobPending()(renderJobData)) {
                    <div class="cm-show-progress">
                        <div class="cm-render-progress-title">
                            Rendering in progress
                            <span class="cm-render-progress-percentage">{{ renderJobData.progress ?? "?" }}%</span>
                            <i matTooltip="{{ renderJobData.id }} - {{ renderJobData.name }} - {{ renderJobData.state }}" class="far fa-circle-info"></i>
                            @if ($can().read.menu("jobs")) {
                                <a [routerLink]="['/jobs', renderJobData.id]" matTooltip="Open this job in the jobs list" class="cm-job-link">
                                    <i class="far fa-up-right-from-square"></i>
                                </a>
                            }
                            <i
                                matTooltip="Refresh preview (Automatically refreshes every 5 minutes)"
                                (click)="refreshJobs()"
                                class="far fa-refresh cm-pointer"
                            ></i>
                            <button class="cm-simple-button cm-inline-cancel-button" (click)="cancelRenderJob()">
                                <i matTooltip="Cancel job" class="fa-solid fa-stop"></i>
                            </button>
                        </div>
                    </div>
                }
            }
            <cm-template-image-viewer-canvas #imageViewerCanvas [postProcessedImageData]="result" (loadingComplete)="$stage.set('done')">
                @if ($stage() === "done") {
                    <cm-template-image-viewer-controls [parent]="imageViewerCanvas" [fileTitle]="$fileTitle()" class="cm-viewer-controls">
                        <ng-container cm-action-items-pos1>
                            <cm-action-item [menuTriggerFor]="deleteMenu" tooltip="Delete" cmIconClass="far fa-trash" class="cm-delete">
                                <mat-menu #deleteMenu>
                                    @if ($overrideRenderJobData()) {
                                        <button (click)="discardRenderJob()" mat-menu-item>Discard image</button>
                                    } @else {
                                        <button (click)="discardRenderJob()" mat-menu-item>Discard image</button>
                                        <button (click)="reRender()" mat-menu-item>Re-render image</button>
                                    }
                                </mat-menu>
                            </cm-action-item>
                        </ng-container>
                    </cm-template-image-viewer-controls>
                }
            </cm-template-image-viewer-canvas>
        }
    }
</div>

<!-- "Render job" becomes a link to the job in the jobs list for staff, otherwise plain text. -->
<ng-template #renderJobLink let-jobId="jobId">
    @if ($can().read.menu("jobs")) {
        <a [routerLink]="['/jobs', jobId]" matTooltip="Open this job in the jobs list" class="cm-render-job-link">Render job</a>
    } @else {
        Render job
    }
</ng-template>
